/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link } from 'react-navi'
import siteMetadata from '../siteMetadata'
import ArticleSummary from './ArticleSummary'
import Pagination from './Pagination'
import styles from './BlogIndexPage.module.css'

function BlogIndexPage({ blogRoot, pageCount, pageNumber, postRoutes }) {
  return (
    <div>
      <header style={{marginBottom: 32}}>
        <h1 className={styles.title}>
          <Link href={blogRoot}>{siteMetadata.title}</Link>
        </h1>
        <div style={{marginBottom: 16}}>
          Hi, I am &nbsp;&nbsp;<b style={{fontSize: 32}}>Abhishek WL.</b><br/>
          I shall be putting up fairly advanced text based tech blogs on a weekly basis.<br/>
        </div>
        <div>
          <a
            href='./rss.xml'
            target='_blank'
            style={{ float: 'right' }}>
            RSS
          </a>
          <Link href='./about'>
            About Me
          </Link> &bull;{' '}
          <Link href='./tags'>
            Tags
          </Link>
        </div>
      </header>

      <ul className={styles.articlesList}>
        {postRoutes.map(route =>
          <li key={route.url.href}>
            <ArticleSummary blogRoot={blogRoot} route={route} />
          </li>
        )}
      </ul>
      {
        pageCount > 1 &&
        <Pagination
          blogRoot={blogRoot}
          pageCount={pageCount}
          pageNumber={pageNumber}
        />
      }
    </div>
  )
}

export default BlogIndexPage